import { render, staticRenderFns } from "./ItemsLibrary.vue?vue&type=template&id=fb2bca42&scoped=true&"
import script from "./ItemsLibrary.vue?vue&type=script&lang=js&"
export * from "./ItemsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ItemsLibrary.vue?vue&type=style&index=0&id=fb2bca42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2bca42",
  null
  
)

export default component.exports